<template>
<div class="activityTempList">
    <div class="search_box">
        <el-input placeholder="输入活动模板名称" v-model="param.eventname" clearable></el-input>
        <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
    </div>
    <div class="add_goods_tabs_box">
        <el-table :data="tableData" style="width: 100%" :show-header="false" ref="multipleTable"
                  @select="handleSelectionChange" @row-click="handleRowChange">
            <el-table-column type="selection" width="30"></el-table-column>
            <el-table-column label="头像">
                <template slot-scope="scope">
                    <div class="image_text">
                        <img class="headerImg" v-lazy="scope.row.coveratturlid" alt>
                        <div class="text">
                            <div>{{scope.row.eventname}}</div>
                            <div class="datetime tc-grey">{{scope.row.datetime}}</div>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="page" style="margin-top: 15px; text-align: center">
        <el-pagination
            background
            @current-change="handleSizeChange"
            :current-page.sync="page.page"
            :page-size="page.pageSize"
            :pager-count="11"
            layout="prev, pager, next"
            :total="total">
        </el-pagination>
    </div>
    <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="handleSure">确 定</el-button>
    </div>
</div>
</template>

<script>
import {getEventListByProviderCopyAdmin} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'activityTempList',
    data() {
        return {
            param: {
                eventname: '',
                providerinnerid: ''
            },
            page: {
                page: 1,
                pageSize: 5,
                pageCount: 0
            },
            total: 0,
            dialogVisible: false,
            tableData: [],
            init: false,
            selectedTemp: null
        }
    },
    mounted() {
    },
    methods: {
        handleSure() {
            this.$router.push({name: 'BBActivityEdit', query: {eventid: this.selectedTemp.eventid,fromeventid: this.selectedTemp.eventid, eventsource: 2 , hostroletype: 2}})
            this.cancel()
        },
        handleSelectionChange(selection, row) {
            this.handleRowChange(row)
        },
        handleRowChange(row) {
            this.$refs.multipleTable.clearSelection()
            this.$refs.multipleTable.toggleRowSelection(row)
            this.selectedTemp = row
        },
        handleSizeChange() {
            this._getList()
        },
        handelQuery() {
            this.page.page = 1
            this._getList()
        },
        cancel() {
            this.$emit('close')
        },
        initParam() {
            this.page.page = 1
            this.param.eventname = ''
            this.param.providerinnerid = ''
            this.selectedTemp = null
            this.init = false
        },
        initList(providerinnerid) {
            this.param.providerinnerid = providerinnerid
            this._getList()
        },
        getList(providerinnerid) {
            if (this.init) return false
            this.param.providerinnerid = providerinnerid
            this._getList()
        },
        _getList() {
            this.setLoading(true)
            getEventListByProviderCopyAdmin({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.init = true
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.activityTempList {
    .search_box{
        display: flex;
        .el-button{
            margin-left: 20px;
            margin-bottom: 0;
        }
    }
    .image_text{
        display: flex;
        .headerImg{
            width: 80px;
            height: 45px;
            margin-right: 10px;
        }
        .text{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-size: 14px;
            .datetime{
                font-size: 12px;
            }
        }
    }
}
</style>
